module.exports = __webpack_public_path__ + "static/media/heist.cd67619d.png";